const SuccessIcon = () => (<i className="icon-wk-dstv-tick-in-circle" />);

export default SuccessIcon;